module.exports = __webpack_public_path__ + "img/sierraint1.e06bf22b.png";